<nz-modal nzTitle="Supplier Info" [(nzVisible)]="isVisible" nzClosable="false" nzMaskClosable="false"
  (nzOnCancel)="cancel()" (nzOnOk)="save()" [nzOkDisabled]="!editing" [nzOkLoading]="validating">
  <ng-container *nzModalContent>
    <form nz-form [formGroup]="form" [nzLayout]="'vertical'" nzSize="small" se-container="1">
      <nz-row nzGutter="8">
        <nz-col nzLg="24" nzMd="24" nzSm="24" nzXs="24">
          <se label="Supplier's Name">
            <nz-input-group nzCompact class="d-flex">
              <app-text-input #name formControlName="supplierName" [maxlength]="250" style="width: 100%;" />
              <app-scan-taxpayer-qr *ngIf="dataSrv.editing" (scanSucess)="onScanSuccess($event)" />
            </nz-input-group>
          </se>
        </nz-col>
        <nz-col nzLg="8" nzMd="12" nzSm="12" nzXs="12" acl="country.MY">
          <se label="ID Type">
            <app-einvoice-ap-tintype-select formControlName="tinType"></app-einvoice-ap-tintype-select>
          </se>
        </nz-col>
        <nz-col nzLg="8" nzMd="24" nzSm="24" nzXs="24">
          <se *aclIf="'country.MY'" [label]="this.regNoLabel">
            <app-text-input #registrationNoMY formControlName="registrationNumber" maxlength="20"
              class="text-uppercase"></app-text-input>
          </se>
          <se *aclIf="'country.PH'" label="TIN">
            <nz-input-group nzCompact class="d-flex">
              <app-view-item text="{{ phTinDisplay }}"></app-view-item>
            </nz-input-group>
          </se>
        </nz-col>

        <nz-col nzLg="8" nzMd="24" nzSm="24" nzXs="24" acl="country.MY">
          <se label="TIN No.">
            <app-einvoice-tin-select-input #tinNumber formControlName="tinNumber" [maxChar]="14" [type]="'supplier'">
            </app-einvoice-tin-select-input>
          </se>
        </nz-col>
        <nz-col nzLg="24" nzMd="24" nzSm="24" nzXs="24" acl="country.MY">
          <se label="MSIC Code">
            <app-einvoice-msic-code-select formControlName="msicCode"></app-einvoice-msic-code-select>
          </se>
        </nz-col>

        <nz-col nzLg="8" nzMd="24" nzSm="24" nzXs="24" acl="country.PH">
          <se label="BIR Category">
            @switch (waCategory) {
            @case (1) {
            <app-view-item text="Private"></app-view-item>
            }
            @case (2) {
            <app-view-item text="Government"></app-view-item>
            }
            @default {
            <app-view-item text=""></app-view-item>
            <!-- Handle null values -->
            }
            }
          </se>
        </nz-col>
        <nz-col nzLg="8" nzMd="24" nzSm="24" nzXs="24" acl="country.PH">
          <se label="BIR Classification">
            @switch (birClassification) {
            @case (1) {
            <app-view-item text="Non individual"></app-view-item>
            }
            @case (2) {
            <app-view-item text="Individual"></app-view-item>
            }
            @default {
            <app-view-item text=""></app-view-item>
            <!-- Handle null values -->
            }
            }
          </se>
        </nz-col>
        <nz-col nzLg="12" nzMd="24" nzSm="24" nzXs="24" acl="country.MY">
          <se label="Sales Tax Reg. No.">
            <app-einvoice-tin-input formControlName="salesTaxRegNo" [maxChar]="35" [allowDash]="true"
              [allowSemiColon]="true"></app-einvoice-tin-input>
          </se>
        </nz-col>

        <nz-col nzLg="12" nzMd="24" nzSm="24" nzXs="24" acl="country.MY">
          <se label="Service Tax Reg. No.">
            <app-einvoice-tin-input formControlName="serviceTaxRegNo" [maxChar]="35" [allowDash]="true"
              [allowSemiColon]="true">
            </app-einvoice-tin-input>
          </se>
        </nz-col>
        <nz-col nzLg="12" nzMd="24" nzSm="24" nzXs="24" acl="country.MY">
          <se label="Country" error="Country is required.">
            <app-einvoice-origin-country-select #country formControlName="country" maxlength="100">
            </app-einvoice-origin-country-select>
          </se>
        </nz-col>
        <nz-col nzLg="12" nzMd="24" nzSm="24" nzXs="24" acl="country.MY">
          <se label="State">
            <app-einvoice-my-state-select #state formControlName="state" maxlength="100" [selectNotApplicableOnly]="
                                                    this.dataSrv.form.controls['country'].value !== null &&
                                                    this.dataSrv.form.controls['country'].value !== 'MY'"
              [hideNotApplicable]="this.dataSrv.form.controls['country'].value === 'MY'">
            </app-einvoice-my-state-select>
          </se>
        </nz-col>
        <nz-col [nzLg]="hideZipCodeField ? 24 : 12" nzMd="24" nzSm="24" nzXs="24" acl="country.MY">
          <se label="City">
            <app-text-input #city formControlName="city" maxlength="50">
            </app-text-input>
          </se>
        </nz-col>
        <nz-col nzLg="12" nzMd="24" nzSm="24" nzXs="24">
          <se label="Zip Code" *ngIf="!hideZipCodeField" acl="country.MY" [required]="isZipcodeReq"
            [error]="isZipcodeReq ? 'Zip Code is required.': ''">
            <app-number-only-input #zip formControlName="zipCode" [maxChar]="5"></app-number-only-input>
          </se>
          <se label="Zip Code" acl="country.PH">
            <app-text-input #zip formControlName="zipCode" maxlength="20">
            </app-text-input>
          </se>
        </nz-col>
        <nz-col nzLg="24" nzMd="24" nzSm="24" nzXs="24">
          <se label="Address">
            <app-memo-input formControlName="billingAddress" rows="5" maxlength="400" [uppercase]="true">
            </app-memo-input>
          </se>
        </nz-col>
        <nz-col nzLg="12" nzMd="24" nzSm="24" nzXs="24">
          <se label="Phone">
            <app-text-input formControlName="phoneNo" maxlength="20" app-mobile-input [allowDialCode]="true"
              class="text-uppercase" />
          </se>
        </nz-col>
        <nz-col nzLg="12" nzMd="24" nzSm="24" nzXs="24">
          <se label="Email" [error]="'Invalid email address'">
            <app-text-input formControlName="email" maxlength="100" />
          </se>
        </nz-col>
      </nz-row>
    </form>
  </ng-container>
  <ng-container *nzModalFooter>
    <div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
      <div *ngIf="canUpdate">
        <button type="button" nz-button nzType="default" [disabled]="!editing || form.invalid" (click)="updateSuppProfile()">Update
          Supplier Profile</button>
      </div>
      <div style="margin-left: auto;">
        <button type="button" nz-button nzType="default" (click)="cancel()">Cancel</button>
        <button type="button" nz-button nzType="primary" [disabled]="!editing || form.invalid" (click)="save()">
          Save
        </button>
      </div>
    </div>
  </ng-container>
</nz-modal>